import React from "react";
import { Box, Typography } from "@mui/material";
import { APP_VERSION } from "../../../constants/version";

const Footer = () => {
  return (
    <Box>
      <Box
        className="displayCenter"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 16px",
        }}
      >
        <Typography
          variant="body2"
          style={{ color: "#000", marginBottom: "5px" }}
        >
          Copyright © 2023{"  "}
          <span className="gradientfirexText" style={{ fontSize: "12px" }}>
            ACROSS ASSIST PVT LTD
          </span>
        </Typography>

        <Typography
          variant="body2"
          style={{ color: "#000", marginBottom: "5px" }}
        >
          {APP_VERSION}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
